// Shared field primitives for the contact detail sections — mirrors the
// FieldLabel/FieldValue pattern used by the product and resale item sections.

export function FieldLabel({ children }: { children: React.ReactNode }) {
  return (
    <span className="font-inter text-sm font-semibold text-grey">
      {children}
    </span>
  );
}

export function FieldValue({ children }: { children: React.ReactNode }) {
  return (
    <p className="font-inter text-sm text-off-black mt-2">
      {children}
    </p>
  );
}

export function SectionTitle({ children }: { children: React.ReactNode }) {
  return (
    <h3 className="font-kapra-expanded text-2xl font-black uppercase leading-tight text-off-black mb-4">
      {children}
    </h3>
  );
}

export function SectionCard({ children }: { children: React.ReactNode }) {
  return (
    <div className="rounded-input border border-dinnerplate-white bg-off-white p-6">
      {children}
    </div>
  );
}
